import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from './confirmation.service';
import { BsModalService, ModalOptions } from 'ngx-bootstrap';
import { ToasterMessageService } from './toaster-message.service';
import { ModalControlService } from './modal-control.service';
import { AttachmentService } from './attachment.service';
import { Globals } from '../objects/Globals';
import { HeaderService } from './header.service';
import { LoginService } from './login.service';
import { MessagePopupService } from './message-popup.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { Subject } from 'rxjs';
import { SidePopupService } from './side-popup.service';

@Injectable({
  providedIn: 'root'
})

/**
 * Workflow return service, this will be the service that will handle all types of workflow return.
 * Changing any code in this method will affect a lot of components, so be VERY AWARE.
 */

export class WorkflowReturnService {

  isLoadingHome: Subject<boolean> = new Subject<boolean>();
  isLoadingHomeChanged = this.isLoadingHome.asObservable();

  constructor(private router: Router, private confirmationService: ConfirmationService, private modalService: BsModalService, private toasterMessageService: ToasterMessageService,
    private modalControlService: ModalControlService, private attachmentService: AttachmentService, private globals: Globals, private headerService: HeaderService, private loginService: LoginService,
    private messagePopupService: MessagePopupService, private sidePopupService: SidePopupService) { }

  handleWorkflowReturn(command: any, directOpenPopup: boolean = true, setHomeUrl: boolean = false){
    /** 
     * If directOpenPopup is set to true, it will open the detail popup straight away in this service.
     * If directOpenPopup set to false means the popup handling will be done in the component instead of here, ex : open by emitting, input output of EPIC
     * Any component that wants to subscribe to this method need to add the handling for loading of goHome method, case 10 in their component
     */
    switch(command.ReturnType){
      case 0: // navigate
        if(command.Arguments){
          var path = [];
          command.Arguments.forEach(element => {
            path.push(element);
          });
          if (setHomeUrl){
            this.globals.Session.HomeUrl = path;
          }
          this.router.navigate(path);
        }
        this.hidesAllModals();
        break;
      case 1: //message
        this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        break;
      case 2: //reload, does nothing, depends on refreshtype
        break;
      case 3: //open detail
        if (directOpenPopup){
          this.openPopup(command.Arguments[0], "");
        }
        if (command.Arguments[1] && command.Arguments[2]){
          this.toasterMessageService.popToast(command.Arguments[1], command.Arguments[2], command.SubType);
        }
        break;
      case 4: //message
        var list = ["parent", "all"];
        if (list.filter(x => x == command.RefreshType).length == 0){
          // this.hidePopup.emit(true);
          if (this.modalService.getModalsCount() > 0){
            this.modalService.hide(this.modalService.getModalsCount());
            if (this.modalService.getModalsCount() == 0) { document.body.classList.remove("modal-open")}
          }
        }
        this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        if (command.Arguments[2] && directOpenPopup){
          this.openPopup(command.Arguments[2], "");
        }
        break;
      case 5: //summary popup
        this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "summary", "modal-summary", command.Arguments[2]);
        break;
      case 6: // comparison
        this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "compare");
        break;
      case 7: //download file
        this.attachmentService.downloadFile(command.Arguments[0]).subscribe(data=>{
          this.downloadFile(data, command.Arguments[1]);
        });
      break;
      case 8:  //messagenavigate
        if (this.globals.Session){
          if(command.Arguments){
            this.handleNavigateAndMessage(command, true, setHomeUrl);
          }
        }
        else{
          this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe((respond) => {
            if (respond.answer == "OK"){
              this.handleNavigateAndMessage(command, false, setHomeUrl);
            }
          });
        }
      break;
      case 9: //chart
        break;
      case 10: // go home and navigate
        this.isLoadingHome.next(true);
        this.loginService.goHome().subscribe(result=>{
          this.isLoadingHome.next(false);
          this.globals.Session.HomeUrl = JSON.parse(result);
          this.router.navigate(this.globals.Session.HomeUrl);
        });
        break;
      case 11: // open form
        this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "form", "modal-form");
        break;
      case 12: // external navigate
        window.open(command.Arguments[0], "_blank");
        break;
      case 13:
        break;
      case 14:
        break;
      case 15:
        this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1] ? command.Arguments[1] : "Report View", "summary", "modal-summary");
        break;
      case 16:
        if (this.modalService.getModalsCount() > 0)
        {
          this.messagePopupService.popMessage("", "Side panel viewing is not supported when clicked from a popup", ["OK"]).subscribe((respond) => {
            if (respond.answer == "OK"){
              console.log("ok");
            }
          });
        }
        else
        {
          this.sidePopupService.createNewPopup(command.Arguments[0]);
        }
        break;
    }

    // if (command.IsPreview){
    //   this.hidePreview();
    // }
  }

  openPopup(event, title: string) {
    // const initialState = {
    //   componentId: event,
    //   title: title
    // };

    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-detail',
      initialState: {
        componentId: event,
        title: title
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalService.show(DetailPopupComponent, config);
  }

  downloadFile(blob: any, fileName:string): void {
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  hidesAllModals(){
    if (this.confirmationService.bsModalRef){
      this.confirmationService.bsModalRef.hide();
    }
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    document.body.classList.remove('modal-open');
    this.sidePopupService.removePopup();
  }

  private hidePreview(){
    if (this.modalService.getModalsCount() > 0){
      this.modalService.hide(this.modalService.getModalsCount());

      this.modalService.onHide.subscribe((reason: string) => {
        if (this.modalService.getModalsCount() == 0){ document.body.classList.remove("modal-open")}
      })
    }
  }
  
  handleNavigateAndMessage(command:any, hasSession:boolean, setHomeUrl: boolean = false){
    var path = [];
    var newArgs = command.Arguments.splice(2);
    newArgs.forEach(element => {
      path.push(element);
    });
    
    if (setHomeUrl){
      this.globals.Session.HomeUrl = path;
    }

    if (hasSession){
      // close all popups
      for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
        this.modalService.hide(i);
      }
      document.body.classList.remove("modal-open");

      this.router.navigate(path);
      this.headerService.setSelectedMenu('clearSelected');
      this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
    }
  }
}

export class WorkflowReturn
{
  IsSuccess: boolean;
  ReturnType: WorkflowReturnType;
  Arguments: string[];
  RefreshType: string; // self, none, parent, all
  SubType: string;
}

enum WorkflowReturnType
{
    // order matters, please do not make any changes to the order this enum
    Navigate,
    Message,
    Reload,
    Detail,
    ClosePopup,
    Summary,
    Compare,
    File,
    MessageNavigate,
    Chart,
    Home,
    Form,
    ExternalNavigate,
    WebContent,
    RefreshDetail,
    ReportSummary,
    SideDetail
}
